import useMaster from "hook/useMaster";
import { useApi } from "libs/data-access";
import { useEffect, useState } from "react";
import { TPaginationStatus } from "types";
import { showToast } from "utils/utility";
import {  IRestriction, ISelectedAirline, ISelectedSupplier } from "./types";
import useApp from "Pages/Hooks/useApp";
 
 
export const localBlockedAirlinesList = [
  {
    id: 1,
    code: "6E",
    isDomesticRestricted: true,
    isInternationalRestricted: true,
    isRestricted: true,
    name: "Indigo",
    status: true,
    supplierName:'Akbar',
    supplierCode: "SG",
    supplierId: 1,
 
  },
  {
    id: 2,
    code: "SG",
    isDomesticRestricted: true,
    isInternationalRestricted: false,
    isRestricted: true,
    name: "Indigo",
    status: true,
    supplierName:'Akbar',
    supplierCode: "SG",
    supplierId: 1,
  },
  {
    id: 3,
    code: "AI",
    isDomesticRestricted: false,
    isInternationalRestricted: true,
    isRestricted: true,
    name: "Indigo",
    status: true,
    supplierName:'Akbar',
    supplierCode: "SG",
    supplierId: 1,
  },
];
 
export const flightTypesList = [
  { label: "Domestic", value: "Domestic" },
  { label: "International", value: "International" },
];
 
export const useBlockAirlines = () => {
  const [isOpenModalValue, setIsOpenModalValue] = useState<"New" | "Edit" | "Delete" | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(false);
  
  const [blockedList, setBlockedList] = useState<IRestriction[]>([]);

  const [supplierList,setSupplierList]=useState<ISelectedSupplier[]>([]);
  const [selectedSupplier, setSelectedSupplier] = useState<ISelectedSupplier | undefined>(undefined);
 
  const [selectedFlightTypes, setSelectedFlightTypes] = useState<string[]>([]);
 
  const [airlinesList, setAirlinesList] = useState<ISelectedAirline[]>([]);
  const [selectedAirlines, setSelectedAirlines] = useState<ISelectedAirline[] | []>([]);
 
  const [editedAirline, setEditedAirline] = useState<IRestriction | undefined>(undefined);
  const [isSwitchLoadingIndex, setIsSwitchLoadingIndex] = useState<number>();
 
  const {
          getData,
          postData,
          patchData,
          putData
      } = useApi();

  const user=JSON.parse(localStorage.getItem("user") || "{}");

 const resetStates = () => {
  setSelectedSupplier(undefined);
  setSelectedFlightTypes([]);
  setSelectedAirlines([]);
  setEditedAirline(undefined);
 }

  useEffect(()=>{
    getAllBlockedAirlinesList();
    getAllSupplier();
  },[]);
 
  useEffect(()=>{
    if(selectedSupplier ){
      getAirlinesList(selectedSupplier?.id);
    }
  },[selectedSupplier])
 
  // Get All Blocked Airlines List
  const getAllBlockedAirlinesList = async () => {
    setIsLoading(true);
    try{
        const response = await getData(`admin/supplier-restrictions/all`);
        if (response.isSuccess) {
          setBlockedList(response.data.data)
        } else {
          showToast({
            type: "error",
            message: response.message ?? "Something went wrong",
            });
          };
    }catch(error){
      setIsLoading(false);
      showToast({
        type: "error",
        message: "Something went wrong",
      });
    }
    finally{
      setIsLoading(false);
    }
  }

  // ----------- Get All Supplier List --------------
  const getAllSupplier=async ()=>{
    try{
        const response=await getData(`admin/supplier-restrictions/suppliers`);
        if(response.isSuccess){
          setSupplierList(response.data.data)
        }else{
            setSupplierList([])
            showToast({
                type: "error",
                message: response.message ?? "Something went wrong",
          });
      };
    }catch(error){
      showToast({
        type: "error",
        message: "Something went wrong",
      });
    }
  }

  // Get Airlines List based on supplier id
  const getAirlinesList = async (idParam?: number) => {
          setIsLoading(true);
          try {
                const payload={
                  supplierId:idParam
                } 
                const response = await postData(`admin/supplier-restrictions/airlines/by-supplier`,payload)
                setIsLoading(false);
 
                if (response.isSuccess) {
                  console.log("airlinesList",response.data.data?.suppliers[0]?.airlines);
                    setAirlinesList(response.data.data?.suppliers[0]?.airlines)
                } else {
                    setAirlinesList([])
                    showToast({
                        type: "error",
                        message: response.message ?? "Something went wrong",
                    });
                };
            }catch (error) {
              showToast({
                  type: "error",
                  message: "Something went wrong",
              });
          } finally {
              setIsLoading(false);
          }
  };
 
  // Submit the selected Airlines to block list
  const submitBlockedAirlines = async () => {
    if(selectedAirlines && selectedAirlines?.length > 0){
      const payload = {
        supplierId: selectedSupplier?.id,
        isRestricted: true,
        airlineIds: selectedAirlines?.map(each => each.id),
        isDomesticRestricted: selectedFlightTypes?.includes("Domestic"),
        isInternationalRestricted: selectedFlightTypes?.includes("International"),
        userId: user?.value?.id
      }
      setIsLoading(true);
      const response = await postData(`admin/supplier-restrictions`, payload);
      setIsLoading(false);
      if(response.isSuccess){
        showToast({
          type: "success",
          message: "Airlines blocked successfully",
        });
        setIsOpenModalValue(undefined);
        resetStates();
        getAllBlockedAirlinesList();
      } else {
        showToast({
          type: "error",
          message: response.message ?? "Something went wrong",
        });
      }
    } else {
      showToast({
        type: "error",
        message: "Please select at least one airline to block",
      });
    }
  };

  // Update the blocked Airlines status
  const updateBlockedAirlines = async (editedAirline:IRestriction) => {
    setIsSwitchLoadingIndex(editedAirline?.id);
    setIsLoading(true);
    try {
        const response = await patchData(`admin/supplier-restrictions/${editedAirline?.id}/toggle?isRestricted=${!editedAirline?.isRestricted}&userId=${user?.value?.id}`);
        if(response.isSuccess){
          showToast({
            type: "success",
            message: "Airlines status updated successfully",
          });
          getAllBlockedAirlinesList();
        } else {
          showToast({
            type: "error",
            message: response.message ?? "Something went wrong",
          });
        }
    } catch (error) {
        showToast({
            type: "error",
            message: "Something went wrong",
        });
    }finally{
        setIsSwitchLoadingIndex(undefined);
        setIsLoading(false);
    }
  }
 
  return {
    blockedList,
    localBlockedAirlinesList,
    isOpenModalValue, setIsOpenModalValue,
    isLoading, setIsLoading,
    supplierList,
    selectedSupplier,setSelectedSupplier,
    airlinesList, setAirlinesList,
    selectedAirlines, setSelectedAirlines,
    isSwitchLoadingIndex, setIsSwitchLoadingIndex,
    submitBlockedAirlines,
    setEditedAirline,
    updateBlockedAirlines,
    resetStates,
    flightTypesList,
    selectedFlightTypes, setSelectedFlightTypes
  };
}
 
 